module.exports = __webpack_public_path__ + "static/media/thumbnail.90888bda.jpg";